enum RouteID {
  ROOT = '/',
  LOGIN = '/login',
  REGISTER = '/register',
  REGISTER_EMAIL = '/register/email',
  REGISTER_PHONE = '/register/phone',
  REGISTER_PHONE_PARAM = '/register/phone/:phone',
  RECOVERY = '/recovery',
  RECOVERY_RESET = '/recovery/reset',
  INVITATIONS = '/invitations',
  TEMPORARY_SIGN_IN = '/temporary_sign_in/:token',
  NOT_FOUND = '*',
}

interface RouteParams {
  phone?: string;
  token?: string;
  resetPasswordToken?: string;
  recoveryEmail?: string;
  invitationToken?: string;
  invitationEmail?: string;
}

interface RouteView {
  id: RouteID;
  path: RoutePath;
  params?: RouteParams;
}

interface IAppLoaderNavigationService {
  initRouter: (routerActions: RouterActions) => void;
  destroy: () => void;
  navigate: (path: RoutePath, triggerPathHandler?: boolean) => void;
  navigateReplacing: (path: RoutePath) => void;
  openUrl: (url: Url, target?: UrlTarget) => void;
  changeUrl: (url: Url) => void;
  reload: () => void;
  openFile: (url: Url | UrlPath) => void;
  getPath: (routeID: RouteID) => RouteID;
  getPathFromWindowHash: () => RoutePath;
  copyToBuffer: (value: string) => Promise<void>;
}

interface RouterHelpers {
  getDefaultRouteView: () => RouteView;
  makeRouteView: (id: RouteID) => RouteView;
}

interface RouterActions {
  navigateToRoute: (routeID: RouteID, params?: RouteParams) => void;
}

export {
  type RouterActions,
  type RouteParams,
  RouteID,
  type RouteView,
  type RouterHelpers,
  type IAppLoaderNavigationService,
};
